import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { SERVER_URL } from "@/config/config";
import {
  bustOut,
  buyOut,
  getJailedUntil,
  getNextBustOutTime,
} from "@/helper/contractFunctions/MafiaJail";
import { JailListType } from "@/types/Jail/JailListType";

export interface JailState {
  jailList: JailListType[];
  isLoadnigJailList: boolean;
  jailedUntil: number;
  nextBustOutTime: number;
  isBuyingOut: boolean;
  isBustingOut: boolean;
}

const initialState: JailState = {
  jailList: [],
  isLoadnigJailList: false,
  jailedUntil: -1,
  nextBustOutTime: -1,
  isBuyingOut: false,
  isBustingOut: false,
};

export const buyOutAction = createAsyncThunk(
  "jail/buyOutAction",
  async ({ address, account }: { address: string; account: string }) => {
    const data = await buyOut(address, account);
    return data.transactionHash;
  }
);

export const bustOutAction = createAsyncThunk(
  "jail/bustOutAction",
  async ({ address, account }: { address: string; account: string }) => {
    const data = await bustOut(address, account);
    return data.transactionHash;
  }
);

export const getJailedUntilAction = createAsyncThunk(
  "jail/getJailedUntilAction",
  getJailedUntil
);

export const getNextBustOutTimeAction = createAsyncThunk(
  "jail/getNextBustOutTimeAction",
  getNextBustOutTime
);

export const getJailList = createAsyncThunk("jail/getJailList", async () => {
  const response = await axios.get(`${SERVER_URL}/profile/jail`);
  return response.data;
});

export const jailSlice = createSlice({
  name: "jail",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getJailList.pending, (state) => {
        state.isLoadnigJailList = true;
      })
      .addCase(getJailList.fulfilled, (state, { payload }) => {
        state.isLoadnigJailList = false;
        state.jailList = payload.map((data: any) => ({
          id: data.id,
          name: data.name,
          jailed: data.jailed,
          jailedUntil: data.jailedUntil,
          city: data.city,
          crimeType: data.crimeType,
          userFamily: data?.userFamily,
        }));
      })
      .addCase(getJailList.rejected, (state) => {
        state.isLoadnigJailList = false;
      })
      .addCase(getJailedUntilAction.fulfilled, (state, { payload }) => {
        state.jailedUntil = payload;
      })
      .addCase(getJailedUntilAction.rejected, (state) => {
        state.jailedUntil = -1;
      })
      .addCase(getNextBustOutTimeAction.fulfilled, (state, { payload }) => {
        state.nextBustOutTime = payload;
      })
      .addCase(getNextBustOutTimeAction.rejected, (state) => {
        state.nextBustOutTime = -1;
      })
      .addCase(buyOutAction.pending, (state) => {
        state.isBuyingOut = true;
      })
      .addCase(buyOutAction.fulfilled, (state) => {
        state.isBuyingOut = false;
      })
      .addCase(buyOutAction.rejected, (state, { error }) => {
        state.isBuyingOut = false;
        console.log(error);
      })
      .addCase(bustOutAction.pending, (state) => {
        state.isBustingOut = true;
      })
      .addCase(bustOutAction.fulfilled, (state) => {
        state.isBustingOut = false;
      })
      .addCase(bustOutAction.rejected, (state, { error }) => {
        state.isBustingOut = false;
        console.log(error);
      });
  },
});

export default jailSlice.reducer;
